import React from 'react';
import cn from 'classnames';

import ShareLink from '../ShareLink';

import useTranslation from '../../features/translation/hooks/useTranslation';
import './Headline.scss';
import useFoXPresence from './hooks/useFoXHeadline';

enum TranslationKeys {
  HEADLINE_NAME = 'headlineName',
  HEADLINE_DESCRIPTION = 'headlineDescription',
}

const Headline: React.FC = () => {
  const t = useTranslation();
  const { hasFoXHeadline } = useFoXPresence();

  return (
    <div className="ems-headline container-fluid">
      <div className="fwe-d-flex fwe-justify-content-space-between">
        {hasFoXHeadline ? null : <h1 className="ems-main-headline">{t(TranslationKeys.HEADLINE_NAME)}</h1>}
        <div data-testid="headline-links" className="ems-headline__links--desktop">
          <ShareLink />
        </div>
      </div>
      {hasFoXHeadline ? null : <div className="ems-sub-heading">{t(TranslationKeys.HEADLINE_DESCRIPTION)}</div>}

      <div
        data-testid="headline-mobile-links"
        className={cn('ems-headline__action-bar', {
          'ems-headline__action-bar--entrypage': true,
        })}
      >
        <div className="ems-headline__links--mobile">
          <ShareLink />
        </div>
      </div>
    </div>
  );
};

export default Headline;
